const ho = {
  backfillRCTForm(controlNumber, PhoenixFormInstanceId) {
    return `/svc/Rct.svc/RctPhoenix/${controlNumber}/MainStreet/${PhoenixFormInstanceId}/Backfill`;
  },
  caseForms(id) {
    return `/homeowner/cases/${id}/caseforms`;
  },
  caseForm(id, caseFormId) {
    return `/homeowner/cases/${id}/caseforms/${caseFormId}`;
  },
  caseInfo(id) {
    return `/homeowner/cases/${id}/case-info`;
  },
  changeStatus(id, newAction) {
    return `/homeowner/cases/${id}/workflow/custom/${newAction}`;
  },
  comparables(id) {
    return `/homeowner/cases/${id}/caseforms/comparables`;
  },
  importMismo(id) {
    return `/mismo/import/${id}`;
  },
  header(id) {
    return `/homeowner/cases/${id}/caseforms/header`;
  },
  contactMethods(id) {
    return `/homeowner/cases/${id}/case-contact-methods`;
  },
  detailedHistory(id) {
    return `/homeowner/cases/${id}/detailed-history`;
  },
  customerDetailedHistory(id) {
    return `/homeowner/cases/${id}/customer-detailed-history`;
  },
  photos(id) {
    return `/homeowner/cases/${id}/photos`;
  },
  validate(id, formId = null) {
    if(formId){
      return `/homeowner/cases/${id}/phoenix-validate/${formId}`;
    } else {
      return `/homeowner/cases/${id}/phoenix-validate/`;
    }
  },
  validationIssues(id) {
    return `/homeowner/cases/${id}/validation-issues`;
  },
  validationStatus(id) {
    return `/homeowner/cases/${id}/validation-status`;
  },
  verosPreview(id) {
    return `/homeowner/cases/${id}/validation-issues/veros-preview`;
  },
  verosSubmit(id) {
    return `/homeowner/cases/${id}/validation-issues/veros-submit`;
  },
  policyInfo(id) {
    return `/homeowner/cases/${id}/policy-info`;
  },
  updateCaseForm(id, caseFormId) {
    return `/homeowner/cases/${id}/caseforms/${caseFormId}`;
  },
  reAddCaseForms(caseFormId, controlIdNumber) {
    return `/homeowner/cases/${controlIdNumber}/case-forms/re-add/${caseFormId}`;
  },
  workflowMethod(id, workflow, method) {
    return `/homeowner/cases/${id}/workflow/${workflow}/${method}`;
  },
  getWorkflowStatus(id) {
    return `/homeowner/cases/${id}/workflow/appraisal-status`;
  },
  appraisalQaRejections(id) {
    return `/homeowner/cases/${id}/appraisal/rejections/qa`;
  },
  appraisalQaRejectionResolve(id, rejectionId) {
    return `/homeowner/cases/${id}/appraisal/rejections/qa/${rejectionId}/resolve`;
  },
  getBrokerCaseHeader(id) {
    return `/homeowner/cases/${id}/broker/header`;
  },
  getBrokerHistory(id) {
    return `/homeowner/cases/${id}/broker/history`;
  },
  getBrokerWaiver(id) {
    return `/homeowner/cases/broker/waiver/${id}`;
  },
  postWaiverDecision() {
    return `/homeowner/cases/broker/waiver/decision`;
  },
  getGridFiltersInsurance() {
    return `/homeowner/cases/gridfilters/insurance`;
  },
  getGridFilterMenus() {
    return `/homeowner/cases/gridfilters/insurance/menus`;
  },
  getGridFiltersValuation() {
    return `/homeowner/cases/gridfilters/valuation`;
  },
  generatePdf(id) {
    return `/homeowner/cases/${id}/pdf/generate`;
  },
  regeneratePdf(id) {
    return `/homeowner/cases/${id}/pdf/regenerate`;
  },
  updateCaseHeader(id) {
    return `/homeowner/cases/${id}/header`;
  },
  getAppraisalFormData(id) {
    return `/homeowner/cases/${id}/appraisal/form/data`;
  },
  setAppraisalFormData(id) {
    return `/homeowner/cases/${id}/appraisal/form/data`;
  },
  changeAppraiserAssigned(appraisalId, appraiserId) {
    return `/homeowner/cases/${appraisalId}/appraiser/${appraiserId}`;
  },
  getPNXFormExportData(id) {
    return `/homeowner/cases/${id}/appraisal/pnx-form-export-data`;
  },
  savePNXFormExportData(id, availFormCode) {
    return `/homeowner/cases/${id}/appraisal/pnx-form-export-data/${availFormCode}`;
  },
  getCaseConversionOptions(id) {
    return `/homeowner/cases/${id}/conversion-options`;
  },
  convertCaseSurveyType(id, surveyTypeCode) {
    return `/homeowner/cases/${id}/convert-case/${surveyTypeCode}`;
  },
  submitCaseToQA(id, isCaseActionRequest = false) {
    let uri = `/homeowner/cases/${id}/submitToQa`;
    if (isCaseActionRequest) {
      uri += `?isCaseActionRequest=true`;
    }
    return uri;
  },
  copyCase() {
    return `/homeowner/cases/copy-case`;
  },
  copyCaseAsCustomer() {
    return `/homeowner/cases/copy-case-customer`;
  },
  getCaseNotifications(id) {
    return `/homeowner/cases/${id}/notifications`;
  },
  cancelCase(controlNumber) {
    return `/homeowner/cases/${controlNumber}/cancel`;
  },
  getAttachment: controlNumber => `/homeowner/cases/${controlNumber}/files`,
  uploadAttachment: (controlNumber, type) => `/homeowner/cases/${controlNumber}/files/${type}`,
  deleteAttachment: (controlNumber, fileName, type) => `/homeowner/cases/${controlNumber}/files/${type}/${fileName}`,
  regeneratePDF: (controlNumber, token) => `/ReportCreatorService/ReportCreator.svc/pdf/${controlNumber}/sync/?SSO=${token}`,
  caseHeaderV2(controlNumber) {
    return `/homeowner/cases/${controlNumber}/header/v2`;
  },
  getCaseHazards: controlNumber => `/homeowner/cases/${controlNumber}/casehazards`,
  getCaseRecommendations: (controlNumber, returnExclusions = false) => `/homeowner/cases/${controlNumber}/recommendations?returnExclusions=${returnExclusions}`,
  getPhoenixFormVersion: controlNumber => `/homeowner/cases/${controlNumber}/phoenix/form/version`,
  caseHoldStatus(controlNumber) {
    return `/homeowner/cases/${controlNumber}/hold`;
  },
  downloadFileAttachments: (controlNumber, type, filename) => `/homeowner/cases/${controlNumber}/files/${type}/${filename}/download`,
  getCaseLinks(controlIdNumber) {
    return `/homeowner/cases/${controlIdNumber}/case-links`;
  },
  phoenixCalculateRctMainStreet: (controlNumber, phoenixFormInstanceId, calcTool) => `/svc/Rct.svc/RctPhoenix/${controlNumber}/MainStreet/${phoenixFormInstanceId}/Calculate?CalcTool=${calcTool}`,
};
export { ho };
